import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {},
  tableHead: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '8fr 6fr 8fr 6fr 6fr 6fr 1fr',
    color: theme.palette.text.secondary,
    alignItems: 'center',
    padding: '0 0 0 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12
  },
  tableHeadAdmin: {
    gridTemplateColumns: '8fr 6fr 8fr 6fr 6fr 6fr 3fr 3fr 1fr'
  },
  tableHeadMobile: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '3fr 1fr',
    color: theme.palette.text.secondary,
    padding: '8px 0 8px 0',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.paper,

    borderRadius: 12,
    alignItems: 'center'
  },
  tableHeadCellMobile: {
    textAlign: 'left',
    paddingLeft: 12
  },
  tableRowRoot: {
    display: 'grid',
    gridTemplateColumns: '40fr 1fr',
    height: 100,
    marginBottom: 4,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    borderRadius: 20,
    cursor: 'pointer',
    paddingLeft: 12,
    transition: 'background-color 0.3s ease-in-out',
    width: '100%',
    textAlign: 'unset',
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    }
  },
  tableRowRootAdmin: {
    gridTemplateColumns: '46fr 1fr'
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '8fr 6fr 8fr 6fr 6fr 6fr',
    width: '100%',
    textAlign: 'unset',
    height: 100,
    alignItems: 'center',
    borderRadius: 20,
    cursor: 'pointer',
    marginBottom: 4
  },
  tableRowAdmin: {
    gridTemplateColumns: '8fr 6fr 8fr 6fr 6fr 6fr 3fr 3fr'
  },
  tableRowSkeleton: {
    display: 'grid',
    gridTemplateColumns: '8fr 6fr 8fr 6fr 6fr 6fr 1fr',
    width: '100%',
    textAlign: 'unset',
    height: 103.2,
    alignItems: 'center',
    borderRadius: 20,
    paddingLeft: 12
  },
  tableRowSkeletonAdmin: {
    gridTemplateColumns: '8fr 6fr 8fr 6fr 6fr 6fr 3fr 3fr 1fr'
  },
  tableRowMobile: {
    display: 'grid',
    gridTemplateColumns: '3fr 1fr',
    height: 100,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    transition: 'background-color 0.3s ease-in-out',
    borderRadius: 20,
    cursor: 'pointer',
    paddingLeft: 12,
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    }
  },
  tableRowMobileSkeleton: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '3fr 1fr',
    color: theme.palette.text.secondary,
    padding: '8px 0 8px 0',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.paper,

    borderRadius: 12
  },
  userLogo: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    background: '#dfdfdf',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12
  },
  nameCell: {
    display: 'flex'
  },
  moreIcon: {
    cursor: 'pointer'
  },
  refreshButtonContainer: {
    margin: 'auto'
  },
  skeleton: {
    width: '50%'
  },
  userInfoContainerSkeleton: {
    width: '80%'
  },
  userInfoNameSkeleton: {
    width: '80%'
  }
}))

export default useStyles
